export default __webpack_public_path__ + "static/media/f_html.f1273592.svg";